import React, { useEffect, useState } from 'react';
import Spinner from '/Foundation/Common/code/Views/Foundation/Common/Spinner';
import SparePartsKeys_ProductList from './SparePartsKeys_ProductList.jsx';
const SparePartsKeys_SearchResult = ({ query, setSelectedProduct, isKeysAndLocks, translations }) => {
    const [products, setProducts] = useState([]);
    const [isloading, setIsLoading] = useState(false);
    useEffect(() => {
        if (query)
            searchProducts();
        else
            setProducts([]);

    }, [query]);

    const searchProducts = () => {
        setIsLoading(true);
        let url = isKeysAndLocks ? "/api/sitecore/keysandlocks/search" : "/api/sitecore/spareparts/autocomplete";

        fetch(`${url}?query=${query}&maxNumberOfHits=50`)
            .then(res => res.json())
            .then(res => {
                if(res.length === 1 && !isKeysAndLocks)
                    setSelectedProduct(res[0])
                else
                    setProducts(res);
            })
            .catch(console.log)
            .finally(() => {
                setIsLoading(false);
            });

    }

    return <div className="sparePartsKeys__searchResult thule-container mt-10 mt-lg-15">
        {isloading && <Spinner />}

        {!isloading && query && <div>
            <p className='paragraph text-color--gray80 mb-5'>{`${products.length} results for`}</p>
            <p className='heading4 mb-5'>“{query}”</p>
        </div>
        }
        {!isKeysAndLocks && products?.length > 0 && <div>
            <ul className='searchResult__container'>
                {products.map((product, index) => {
                    return <li key={index} className='searchResult__item'>
                        <div className='item__imgContainer mb-3 mb-lg-4'>
                            <button className="btn p-0 d-flex w-100 justify-content-center" onClick={() => { setSelectedProduct(product) }}>
                                {product.ImageUrl ? <img src={product.ImageUrl} alt={product.Color} /> : <i className='le-icon-image-off'></i>}
                            </button>
                        </div>
                        <h2 className='heading5 mb-2'>{product.ProductName}</h2>
                        <p className='item__description paragraph--s mb-0'>{product.WebTitle2}</p>
                    </li>
                })}
            </ul>
        </div>}
        {isKeysAndLocks && products.length > 0 && <SparePartsKeys_ProductList translations={translations} isKeysAndLocks={isKeysAndLocks} spareParts={products} />}
    </div>;
}

export default SparePartsKeys_SearchResult;